import type { Font } from '../types/font';

export const interV11: Font = {
  fontFamily: 'inter-v11-rw27kGjDd-P-Tez_aaqH4',
  displayName: 'Inter',
  sources: [
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'inter-v11-vietnamese-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'inter-v11-cyrillic-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillicExt',
      src: 'inter-v11-cyrillic-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillicExt',
      src: 'inter-v11-cyrillic-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'inter-v11-cyrillic-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greek',
      src: 'inter-v11-greek-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greekExt',
      src: 'inter-v11-greek-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greekExt',
      src: 'inter-v11-greek-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'inter-v11-greek-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'inter-v11-latin-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'inter-v11-latin-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'inter-v11-latin-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'inter-v11-latin-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'inter-v11-vietnamese-regular.woff2',
      format: 'woff2',
    },
  ],
};
